import VueI18n from 'vue-i18n'
import Vue from 'vue'
import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGE } from '@/constants/trans'
import th from '@/lang/th.json'
import en from '@/lang/en.json'
Vue.use(VueI18n)


export const i18n = new VueI18n({
  locale: DEFAULT_LANGUAGE, // set locale
  fallbackLocale: FALLBACK_LANGUAGE,
  messages: { th,en } // set locale messages
})

if (module.hot) {
  module.hot.accept(['@/lang/en.json', '@/lang/th.json'], function () {
    // i18n.setLocaleMessage('en', require('@/lang/en.json').default)
    // i18n.setLocaleMessage('th', require('@/lang/th.json').default)
    // Or the following hot updates via $i18n property
    app.$i18n.setLocaleMessage('en', require('@/lang/en.json').default)
    app.$i18n.setLocaleMessage('th', require('@/lang/th.json').default)
  })
}